import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, intlShape } from 'react-intl';

import BcReactComponent from '@bibliocommons/base-bc-react-component';
import Checkbox from '@bibliocommons/base-checkbox';

export class SingleBranchStatusField extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleToggleFilter');
  }

  handleToggleFilter() {
    this.props.handleToggleFilter(this.props.fieldId, this.props.filter);
  }

  render() {
    const { filter, label } = this.props;
    const value = filter.get('value');

    let classString = 'filter';
    if (filter.get('applied')) {
      classString += ' applied';
    }
    const formattedLabel = this.props.intl.formatMessage({ id: label });

    return (
      <li key={`${this.props.fieldId}-${value}`} className={classString}>
        <Checkbox
          id={`field-${value}`}
          handleChange={this.handleToggleFilter}
          checked={filter.get('applied')}
          label={formattedLabel} />
      </li>
    );
  }
}

SingleBranchStatusField.propTypes = {
  filter: ImmutablePropTypes.map,
  label: PropTypes.string.isRequired,
  activeFilters: ImmutablePropTypes.list,
  intl: intlShape
};

export default injectIntl(SingleBranchStatusField);



// WEBPACK FOOTER //
// ./app/components/search/SingleBranchStatusField.jsx